/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const CampusIcon = createIcon({
  displayName: "CampusIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path d="M6 9.25H7.5V10.75H6V9.25Z" fill="currentColor" />
      <path d="M9.25 9.25V10.75H10.75V9.25H9.25Z" fill="currentColor" />
      <path d="M9.25 6H10.75V7.5H9.25V6Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2L14 3V14H2V7L6 6V2ZM7.5 7.17116V3.69917L12.5 4.32417V12.5H3.5V8.17116L7.5 7.17116Z"
        fill="currentColor"
      />
    </g>
  )
});
